import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const VariantSelectorSection = styled.section`
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray200')};
    padding: ${getPurpurSpacing('600')} 0;
`;

export const BadgeBlockTitle = styled.div`
    display: flex;
    align-items: center;
    gap: ${getPurpurSpacing('200')};
    margin-top: 0;
    margin-bottom: ${getPurpurSpacing('150')};
    & ~ & {
        margin-top: ${getPurpurSpacing('400')};
    }
`;

export const BadgeBlockOutOfStockLabel = styled.mark`
    background-color: unset;
    color: ${getPurpurColor('textStatusErrorMedium')};
    font-size: 0.875rem;
    font-weight: normal;
`;

export const BadgeBlockContainer = styled.div.attrs({ role: 'radiogroup' })`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};
`;

export const BadgeBlockInfoContainer = styled.div`
    margin-top: ${getPurpurSpacing('200')};
`;
